import { render, staticRenderFns } from "./HighlightButton.vue?vue&type=template&id=6ac64778&scoped=true&"
import script from "./HighlightButton.vue?vue&type=script&lang=js&"
export * from "./HighlightButton.vue?vue&type=script&lang=js&"
import style0 from "./HighlightButton.vue?vue&type=style&index=0&id=6ac64778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac64778",
  null
  
)

export default component.exports